import { Component } from '@angular/core';

import { ApInputSkeletonComponent, ApButtonSkeletonComponent } from '@ap/skeleton';

/**
 * @ngdoc component
 * @name ApDigicodeSkeletonComponent
 */
@Component({
    selector: 'ap-digicode-skeleton',
    standalone: true,
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
    imports: [ApInputSkeletonComponent, ApButtonSkeletonComponent]
})
export class ApDigicodeSkeletonComponent {}
